import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { ref } from 'vue'
import { adminAreaSave, adminAreaUpdate } from '@/api/overseasSales/administrativeRegion'
import type { FormInstance } from 'ant-design-vue'
import { DcMessage } from '@dc-platform/dc-components'
import { adminAreaSaveParams } from '@/typings/api/overseasSales'

const __default__ = { name: 'editModal' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<adminAreaSaveParams>({})
const emit = __emit
const toggle = (row?: adminAreaSaveParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
    console.log('editForm.value: ', editForm.value)
  } else {
    editForm.value = {}
  }
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = editForm.value
    try {
      if (editForm.value.id) {
        await adminAreaUpdate({
          ...p,
          id: editForm.value.id,
          level: 1,
          name: editForm.value.countryCnName,
          fullName: editForm.value.countryCnName
        })
      } else {
        await adminAreaSave({
          ...p,
          parentId: '-1',
          level: 1,
          name: editForm.value.countryCnName,
          fullName: editForm.value.countryCnName
        })
      }
      toggle()
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? '编辑成功' : '新增成功')
    } catch (error) {
      loading.value = false
    }
  })
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!
  const _directive_trim = _resolveDirective("trim")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
    title: editForm.value.id ? '编辑' : '新增',
    width: "600px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef,
            autocomplete: "off"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "countryCharCode",
                label: "国家二字码",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_a_input, {
                    value: editForm.value.countryCharCode,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.countryCharCode) = $event)),
                    placeholder: "请输入"
                  }, null, 8, ["value"]), [
                    [_directive_trim]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "countryCnName",
                label: "国家中文名",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_a_input, {
                    value: editForm.value.countryCnName,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.countryCnName) = $event)),
                    placeholder: "请输入"
                  }, null, 8, ["value"]), [
                    [_directive_trim]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "countryEnName",
                label: "国家英文名",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_a_input, {
                    value: editForm.value.countryEnName,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((editForm.value.countryEnName) = $event)),
                    placeholder: "请输入"
                  }, null, 8, ["value"]), [
                    [_directive_trim]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})